import * as React from 'react';
import styled from 'styled-components';

import { IconAlertsDanger } from '@doltech/icons/IconAlertsDanger';
import { deviceBreakpoints } from '../../hooks/useDeviceQuery.hook';
import { colorsV2 } from '../colors-v2';
import { Typography } from '../DesignSystemV2/Typography';
import { Box } from '../Common/BoxV2';
import { ResponsiveContainer, ResponsiveContainerProps } from './components/ResponsiveContainer';

const Container = styled.div`
  background-color: ${colorsV2.yellow20};
  border: 1px solid ${colorsV2.yellow40};
  padding: 16px;

  ul {
    padding-inline-start: 24px;
  }

  @media screen and ${deviceBreakpoints.fromTablet} {
    border-radius: 8px;
    padding: 24px;
  }
`;

interface WarningBannerProps extends ResponsiveContainerProps {}

export const WarningBanner = (props: WarningBannerProps) => {
  const { responsive, ...rest } = props;

  return (
    <ResponsiveContainer className={responsive} {...rest}>
      <Container>
        <Box display="flex" alignItems="center" mb="16px">
          <IconAlertsDanger fontSize={16} mr="8px" />
          <Typography.Title level={5} variant="semi-bold/16">
            Lưu ý
          </Typography.Title>
        </Box>

        <ul>
          <li>
            Nội dung giải thích được viết bởi DOL IELTS Đình Lực - Học Viện Tiếng Anh Tư Duy đầu
            tiên tại Việt Nam
          </li>
          <li>Đề được viết bởi nhà xuất bản lớn gồm Cambridge và Oxford</li>
        </ul>
      </Container>
    </ResponsiveContainer>
  );
};
